/*
react-git-info - npm
https://www.npmjs.com/package/react-git-info
 */
// import GitInfo from "react-git-info/macro";

/*
Javascript Date 的健忘筆記 - ScottChayaa
https://blog.scottchayaa.com/post/2019/05/27/javascript_date_memo/
 */
///* eslint-disable-next-line */
Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, //月份
    'd+': this.getDate(), //日
    'h+': this.getHours(), //小時
    'm+': this.getMinutes(), //分
    's+': this.getSeconds(), //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };

  const match = fmt.match(/(y+)/);
  if (match) {
    const str = match[1];
    fmt = fmt.replace(str, (this.getFullYear() + '').substring(4 - str.length));
  }

  for (var k in o) {
    const matchPattern = new RegExp(`(${k})`).exec(fmt);
    if (matchPattern) {
      const str = matchPattern[1];
      fmt = fmt.replace(str, str.length === 1 ? o[k] : ('00' + o[k]).slice(('' + o[k]).length));
    }
  }
  return fmt;
};

// 從 Vite define 中獲取 Git 資訊（會被替換為 JSON 字串，需要解析）
function getGitInfo() {
  try {
    // Vite define 會將 __GIT_INFO__ 替換為 JSON 字串
    if (typeof __GIT_INFO__ === 'string') {
      return JSON.parse(__GIT_INFO__);
    }
    return __GIT_INFO__;
  } catch (error) {
    console.warn('Failed to parse git info:', error);
    return {
      branch: 'unknown',
      commit: {
        shortHash: 'unknown',
        hash: 'unknown',
        date: new Date().toISOString(),
        message: 'unknown',
      },
    };
  }
}

export const gitInfo = getGitInfo();

export default function showVersion(showOnConsole = true, onlyAppVer = false) {
  // Vite define 會將 VITE_APP_VERSION 替換為 JSON 字串
  let appVer;
  try {
    if (typeof VITE_APP_VERSION === 'string' && VITE_APP_VERSION.startsWith('"')) {
      appVer = JSON.parse(VITE_APP_VERSION);
    } else {
      appVer = VITE_APP_VERSION;
    }
  } catch {
    appVer = 'unknown';
  }

  // const gitInfo = GitInfo();
  const gitInfo = getGitInfo();
  // console.log('showVersion', gitInfo);
  // console.log(gitInfo.branch);
  // console.log(gitInfo.tags);
  // console.log(gitInfo.commit.date);
  // console.log(gitInfo.commit.hash);
  // console.log(gitInfo.commit.message);
  // console.log(gitInfo.commit.shortHash);

  const gitVer = new Date(gitInfo.commit.date).format('yyyyMMdd.hhmmss');
  // console.log(appVer);

  // version branch hash
  // e.g. 20230526.134453 dev 1ad880e
  // const txtVer = gitVer +' '+ gitInfo.branch +' '+ gitInfo.commit.shortHash;
  const txtVer =
    'version ' + appVer + '.' + gitVer + ' ' + gitInfo.branch + ' ' + gitInfo.commit.shortHash;
  // const txtVer = 'version ' + appVer;
  if( showOnConsole )
    Function('msg', 'console.log(msg)')(txtVer);
  
  if(onlyAppVer)
    return `${appVer}.${gitVer}`
  else
    return txtVer;
}
